module.exports = __webpack_public_path__ + "img/avatar.c6092bdc.svg";